import "./moonbase-product-card.js";
import { initVideoLoading } from "./moonbase-video.js";
import "./moonbase-localization-form.js";
import { setHeaderHeight } from "./moonbase-header.js";
var en_default_default = {
	general: {
		"actions": {
			"log_in": "Log in",
			"log_out": "Log out",
			"register": "Register",
			"account": "Account",
			"cart": "Bag",
			"close": "Close"
		},
		"accessibility": {
			"close_overlay_button": "Close overlay button",
			"unit_price_separator": "per",
			"error": "Error",
			"back_to_top": "Back to top",
			"link_messages": { "new_window": "Opens in a new window." },
			"carousel": {
				"carousel_pagination": "Carousel pagination",
				"previous_slide": "Previous slide",
				"next_slide": "Next slide"
			}
		},
		"social": {
			"links": {
				"facebook": "https://www.facebook.com/",
				"twitter": "https://twitter.com/",
				"instagram": "https://instagram.com/",
				"pinterest": "https://pinterest.com/",
				"tiktok": "https://tiktok.com/",
				"youtube": "https://youtube.com/",
				"snapchat": "https://snapchat.com/",
				"tumblr": "https://tumblr.com/",
				"vimeo": "https://vimeo.com/"
			},
			"sharing": {
				"share": "Share",
				"facebook_alt_text": "Facebook",
				"twitter_alt_text": "Twitter",
				"pinterest_alt_text": "Pinterest",
				"instagram_alt_text": "Instagram",
				"youtube_alt_text": "YouTube",
				"tiktok_alt_text": "TikTok",
				"snapchat_alt_text": "Snapchat",
				"tumblr_alt_text": "Tumblr",
				"vimeo_alt_text": "Vimeo"
			}
		},
		"search": {
			"title": "Search",
			"results_with_count_and_terms": {
				"one": "{{ count }} result for \"{{ terms }}\"",
				"other": "{{ count }} results for \"{{ terms }}\""
			},
			"results_with_count": {
				"one": "{{ count }} result",
				"other": "{{ count }} results"
			},
			"no_results": "No results found, try checking your spelling or using different words.",
			"products": "Products ({{ count }})",
			"collections": "Collections",
			"pages": "Pages",
			"suggestions": "Suggestions",
			"search_with": "Search for \"{{ terms }}\"",
			"reset": "Reset"
		},
		"pagination": {
			"label": "Pagination",
			"page": "Page {{ number }}",
			"next": "Next",
			"previous": "Prev",
			"next_page": "Next page",
			"previous_page": "Previous page",
			"show_more": "Show More",
			"loading": "Loading more..."
		},
		"newsletter": {
			"label": "Submit",
			"placeholder": "Email Address",
			"success": "Thank you for signing up!"
		},
		"404": {
			"title": "404",
			"subtitle": "Ooops. This page cannot be found.",
			"text": "The page you are looking for might have been removed, had its name changed, or is temporarily unavailable. Feel free to click below to go back to the last page you were on.",
			"buttons": {
				"home": "Home",
				"previous": "Back"
			}
		}
	},
	layout: {
		"header": { "search": {
			"label": "Search",
			"submit": "Search"
		} },
		"footer": {
			"newsletter": { "label_screen_reader_text": "Newsletter email address" },
			"payment_methods": { "supported_payment_methods": "Supported payment methods" },
			"powered_by": "&copy; {{ date }} Powered by Shopify"
		},
		"navigation": {},
		"localization": {
			"country_label": "Country/region",
			"language_label": "Language",
			"update_language": "Update language",
			"update_country": "Update country/region",
			"search": "Search",
			"popular_countries_regions": "Popular countries/regions",
			"country_results_count": "{{ count }} countries/regions found"
		}
	},
	products: {
		"product": {
			"volume_pricing": {
				"title": "Volume Pricing",
				"note": "Volume pricing available",
				"cart_note": "Volume Pricing will be reflected in the cart and checkout.",
				"price_at_each": "at /ea"
			},
			"delivery": {
				"title": "Home Delivery",
				"home_delivery": "Home delivery within 2-3 working days",
				"find_stockist": "Find a stockist",
				"stock_levels_note": "Stock levels vary by location",
				"learn_more_label": "Learn More",
				"order_dispatch_note": "Orders dispatch within 1–2 working days (Mon–Fri)."
			},
			"bundle": { "title": "What's included in your pack" },
			"on_sale": "On Sale",
			"unavailable": "Unavailable",
			"sold_out": "Sold Out Online",
			"add_to_cart": "Add to Basket",
			"choose_options": "Choose options",
			"choose_product_options": "Choose options for {{ product_name }}",
			"description": "Description",
			"inventory_in_stock": "In stock",
			"inventory_in_stock_show_count": "In Stock",
			"inventory_low_stock": "Low stock",
			"inventory_low_stock_show_count": "Low stock: {{ quantity }} left",
			"inventory_out_of_stock": "Out of stock",
			"inventory_out_of_stock_continue_selling": "In stock",
			"sku": "SKU",
			"product_variants": "Product variants",
			"share": "Share this product",
			"vendor": "Vendor",
			"value_unavailable": "{{ option_value }} - Unavailable",
			"variant_sold_out_or_unavailable": "Variant sold out or unavailable",
			"video_exit_message": "{{ title }} opens full screen video in same window.",
			"view_full_details": "View full details",
			"xr_button": "View in your space",
			"xr_button_label": "View in your space, loads item in augmented reality window",
			"include_taxes": "Tax included.",
			"shipping_policy_html": "<a href=\"{{ link }}\">Shipping</a> calculated at checkout.",
			"learn_more_about": "Learn more about {{ product }}",
			"media": {
				"gallery_viewer": "Gallery Viewer",
				"load_image": "Load image {{ index }} in gallery view",
				"load_model": "Load 3D Model {{ index }} in gallery view",
				"load_video": "Play video {{ index }} in gallery view",
				"image_available": "Image {{ index }} is now available in gallery view",
				"open_media": "Open media {{ index }} in modal",
				"play_model": "Play 3D Viewer",
				"play_video": "Play video"
			},
			"quantity": {
				"label": "Quantity",
				"input_label": "Quantity for {{ product }}",
				"increase": "Increase quantity for {{ product }}",
				"decrease": "Decrease quantity for {{ product }}",
				"minimum_of": "Minimum of {{ quantity }}",
				"maximum_of": "Maximum of {{ quantity }}",
				"multiples_of": "Increments of {{ quantity }}",
				"in_cart_html": "<span class=\"quantity-cart\">{{ quantity }}</span> in bag"
			},
			"pickup_availability": {
				"view_store_info": "View store information",
				"check_other_stores": "Check availability at other stores",
				"pick_up_available": "Pickup available",
				"pick_up_available_at_html": "Pickup available at <span class=\"color-foreground\">{{ location_name }}</span>",
				"pick_up_unavailable_at_html": "Pickup currently unavailable at <span class=\"color-foreground\">{{ location_name }}</span>",
				"unavailable": "Couldn't load pickup availability",
				"refresh": "Refresh"
			},
			"price": {
				"from_price_html": "From {{ price }}",
				"regular_price": "Regular price",
				"sale_price": "Sale price",
				"unit_price": "Unit price"
			},
			"subscriptions": { "one_time_purchase": "One-time purchase" }
		},
		"card": { "placeholder_title": "Placeholder Title" },
		"facets": {
			"apply": "Apply",
			"clear": "Clear",
			"refresh_page_message": "Please refresh the page to see the updated results.",
			"clear_all": "Remove all",
			"from": "From",
			"filter_and_sort": "Filter and sort",
			"filter_by_label": "Filters",
			"filter_button": "Filter",
			"filters_selected": {
				"one": "{{ count }} selected",
				"other": "{{ count }} selected"
			},
			"filter_selected_accessibility": "{{ type }} ({{ count }} filters selected)",
			"show_more": "Show more",
			"show_less": "Show less",
			"max_price": "The highest price is {{ price }}",
			"product_count": {
				"one": "{{ product_count }} of {{ count }} product",
				"other": "{{ product_count }} of {{ count }} products"
			},
			"product_count_simple": {
				"one": "{{ count }} product",
				"other": "{{ count }} products"
			},
			"reset": "Reset",
			"sort_button": "Sort",
			"sort_by_label": "Sort by:",
			"to": "To",
			"clear_filter": "Remove filter"
		},
		"bulk": { "form": {
			"headings": {
				"size": "Size",
				"colour": "Colour"
			},
			"image": "Image",
			"title": "Product Title",
			"price": "Price",
			"quantity": "Quantity",
			"available": "{{ quantity }} Available",
			"totals": {
				"quantity": "Total Qty",
				"general": "Total"
			},
			"add_to_cart": "Add to Cart"
		} }
	},
	collections: { "listing": {
		"title": "All Collections",
		"view_collection": "View Collection",
		"no_collections": "There are no collections yet.",
		"no_products": "There are no products in this collection."
	} },
	cart: {
		"general": {
			"title": "Shopping Basket",
			"empty_cart_title": "Shopping Basket",
			"empty_cart_notice": "Your bag is currently empty.",
			"original_price": "Original Price",
			"sale_price": "Sale Price",
			"quantity_title": "Quantity:",
			"remove": "Remove",
			"continue_shopping": "Continue shopping"
		},
		"summary": {
			"delivery_options": "Orders dispatch within 1–2 working days (Mon–Fri).",
			"summary_title": "Summary",
			"subtotal_title": "Subtotal",
			"item_count": {
				"one": "{{ count }} item",
				"other": "{{ count }} items"
			},
			"shipping_and_tax_notice": "Tax included and shipping calculated at checkout",
			"note_title": "Add any notes or special instructions:",
			"supported_payment_methods": "Supported payment methods",
			"checkout_button": "Checkout"
		},
		"table": {
			"header": {
				"product": "Product",
				"price": "Price",
				"quantity": "Quantity",
				"total": "Total"
			},
			"item": {
				"remove": "Remove",
				"quantity": "Quantity",
				"total": "Total",
				"product": "Product",
				"price": "Price"
			}
		},
		"minicart": {
			"title": "Added to your basket",
			"complete_your_kit": "Complete your kit",
			"cart_note": "Special instructions for seller",
			"footer": { "title": "Summary" },
			"close": "Close",
			"remove": "Remove",
			"quantity": "Quantity",
			"totals": { "item_count": {
				"one": "{{ count }} product",
				"other": "{{ count }} products"
			} },
			"payment_methods": {
				"title": "Shipping & taxes calculated at checkout",
				"supported": "Supported payment methods"
			},
			"button": {
				"checkout": "Checkout - ",
				"continue_shopping": "Continue shopping",
				"view_cart": "View cart"
			},
			"summary": { "view_cart": "View bag" }
		},
		"shipping_threshold": {
			"title": "You are {{ remaining }} away from free shipping",
			"success": "You have received free shipping!"
		},
		"toast": { "added_to_bag": "Added to bag" }
	},
	customer: { "account": {
		"title": "My Account",
		"welcome": "Hello {{first_name}}",
		"logout": "Log Out"
	} },
	sections: {
		"main_product": {
			"delivery_options": {
				"heading": "How would you like to get this item?",
				"home_delivery": "Home delivery within 2-3 working days",
				"stock_levels_note": "Stock levels vary by location"
			},
			"complementary_products": {
				"heading": "Complete your kit",
				"add_product": "Add Product"
			},
			"stock": { "in_stock": "In stock" },
			"accordions": {
				"product_description": "Product Description",
				"ingredients_and_nutrition": "Ingredients and Nutrition"
			}
		},
		"quick_order_list": { "each": "Each {{ money }}" },
		"contact_form": {
			"contact_details_title": "Prefer to call or email?",
			"form": {
				"name": "Name",
				"email": "Email",
				"phone": "Phone",
				"message": "Message",
				"submit": "Send",
				"successfully_sent": "Your message has been successfully sent."
			}
		},
		"password": {
			"text": "Please enter the password to enter the store.",
			"submit": "Submit"
		},
		"fuelling_guide": {
			"before": "Before",
			"during": "During",
			"after": "After"
		}
	},
	blogs: {
		"tags": {
			"all_text": "All",
			"all_title": "Show all articles"
		},
		"article": { "read_more": "Read more" },
		"comments": {
			"error_heading": "Please adjust the following:",
			"header": "Comments",
			"name": "Name",
			"email": "Email",
			"comment": "Comment",
			"post": "Post comment",
			"moderated": "Please note, comments need to be approved before they are published.",
			"success": "Your comment was posted successfully! Thank you!",
			"success_moderated": "Your comment was posted successfully. We will publish it in a little while, as our blog is moderated."
		}
	},
	gift_cards: { "issued": {
		"title": "Here's your {{ value }} gift card for {{ shop }}!",
		"how_to_use_gift_card": "How to use your gift card",
		"subtext": "Your gift card",
		"gift_card_code": "Gift card code",
		"shop_link": "Continue shopping",
		"remaining_html": "Remaining {{ balance }}",
		"add_to_apple_wallet": "Add to Apple Wallet",
		"qr_image_alt": "QR code — scan to redeem gift card",
		"copy_code": "Copy code",
		"expired": "Expired",
		"expiration_date": "Expires {{ expires_on }}",
		"copy_code_success": "Copy gift card code",
		"print_gift_card": "Print"
	} },
	recipient: { "form": {
		"checkbox": "I want to send this as a gift",
		"expanded": "Gift card recipient form expanded",
		"collapsed": "Gift card recipient form collapsed",
		"email_label": "Recipient email",
		"email_label_optional_for_no_js_behavior": "Recipient email (optional)",
		"email": "Email",
		"name_label": "Recipient name (optional)",
		"name": "Name",
		"message_label": "Message (optional)",
		"message": "Message",
		"max_characters": "{{ max_chars }} characters max",
		"send_on": "YYYY-MM-DD",
		"send_on_label": "Send on (optional)"
	} },
	wishlist: { "title": "Wishlist" }
};
//#endregion
//#region src/main.js
var trapFocusHandlers = {};
function getFocusableElements(container) {
	return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}
function removeTrapFocus(elementToFocus = null) {
	document.removeEventListener("focusin", trapFocusHandlers.focusin);
	document.removeEventListener("focusout", trapFocusHandlers.focusout);
	document.removeEventListener("keydown", trapFocusHandlers.keydown);
	if (elementToFocus) elementToFocus.focus();
}
function trapFocus(container, elementToFocus = container) {
	const elements = getFocusableElements(container);
	const first = elements[0];
	const last = elements[elements.length - 1];
	removeTrapFocus();
	trapFocusHandlers.focusin = (event) => {
		if (event.target !== container && event.target !== last && event.target !== first) return;
		document.addEventListener("keydown", trapFocusHandlers.keydown);
	};
	trapFocusHandlers.focusout = function() {
		document.removeEventListener("keydown", trapFocusHandlers.keydown);
	};
	trapFocusHandlers.keydown = function(event) {
		if (event.code.toUpperCase() !== "TAB") return;
		if (event.target === last && !event.shiftKey) {
			event.preventDefault();
			first.focus();
		}
		if ((event.target === container || event.target === first) && event.shiftKey) {
			event.preventDefault();
			last.focus();
		}
	};
	document.addEventListener("focusout", trapFocusHandlers.focusout);
	document.addEventListener("focusin", trapFocusHandlers.focusin);
	elementToFocus.focus();
}
(async () => {
	window.Moonbase = window.Moonbase || {};
	window.Moonbase.locales = en_default_default;
	const Moonbase = window.Moonbase;
	document.documentElement.className = document.documentElement.className.replace("no-js", "js");
	const cartIcon = document.querySelector("#cart-icon");
	const minicartSection = document.getElementById("shopify-section-minicart");
	let minicartReturnFocusTarget = cartIcon;
	let pendingMinicartFocusKey = null;
	const getMinicartPanel = () => minicartSection?.querySelector("[data-ajax-cart-section]");
	const getMinicartCloseButton = () => minicartSection?.querySelector("[close-overlay-button]");
	const isMinicartOpen = () => document.body.classList.contains(Moonbase.classes.minicartOpen);
	const syncMinicartAccessibility = (open) => {
		if (!minicartSection) return;
		minicartSection.inert = !open;
		if (!open) minicartSection.setAttribute("aria-hidden", "true");
		else minicartSection.removeAttribute("aria-hidden");
		cartIcon?.setAttribute("aria-expanded", String(open));
	};
	const getFocusTarget = (element) => {
		if (!(element instanceof HTMLElement)) return cartIcon;
		if (element.matches("ajax-cart-product-form")) return element.querySelector("[type=\"submit\"]") || cartIcon;
		return element;
	};
	const getMinicartFocusKey = (element) => element instanceof HTMLElement ? element.closest("[data-minicart-focus-key]")?.getAttribute("data-minicart-focus-key") : null;
	const openMinicart = (returnFocusTo = cartIcon) => {
		if (window.matchMedia("(min-width: 1100px)").matches) return;
		const panel = getMinicartPanel();
		const closeButton = getMinicartCloseButton();
		if (!panel) return;
		minicartReturnFocusTarget = getFocusTarget(returnFocusTo);
		document.body.classList.add(Moonbase.classes.minicartOpen);
		syncMinicartAccessibility(true);
		trapFocus(panel, closeButton || panel);
	};
	const closeMinicart = (returnFocusTo = minicartReturnFocusTarget) => {
		const focusTarget = returnFocusTo instanceof HTMLElement && document.contains(returnFocusTo) ? returnFocusTo : cartIcon;
		document.body.classList.remove(Moonbase.classes.minicartOpen);
		syncMinicartAccessibility(false);
		pendingMinicartFocusKey = null;
		removeTrapFocus(focusTarget);
	};
	document.addEventListener("liquid-ajax-cart:request-start", () => {
		pendingMinicartFocusKey = isMinicartOpen() && getMinicartPanel()?.contains(document.activeElement) ? getMinicartFocusKey(document.activeElement) : null;
	});
	document.addEventListener("liquid-ajax-cart:request-end", (event) => {
		const { requestState } = event.detail;
		const initiator = requestState.info?.initiator;
		const focusKey = pendingMinicartFocusKey;
		pendingMinicartFocusKey = null;
		if (requestState.requestType === "add" && requestState.responseData?.ok) {
			openMinicart(initiator);
			return;
		}
		if (!isMinicartOpen()) return;
		window.requestAnimationFrame(() => {
			const panel = getMinicartPanel();
			const closeButton = getMinicartCloseButton();
			const focusTarget = focusKey ? panel?.querySelector(`[data-minicart-focus-key="${CSS.escape(focusKey)}"]`) : null;
			if (!panel) return;
			trapFocus(panel, focusTarget || closeButton || panel);
		});
	});
	document.addEventListener("click", (event) => {
		if (!(event.target instanceof Element)) return;
		if (event.target.closest("[close-overlay-button]") || isMinicartOpen() && event.target.closest(".site-overlay")) closeMinicart();
	});
	document.addEventListener("keydown", (event) => {
		const panel = getMinicartPanel();
		if (!isMinicartOpen() || event.code.toUpperCase() !== "ESCAPE" || !panel) return;
		if (!panel.contains(document.activeElement)) return;
		event.preventDefault();
		closeMinicart();
	});
	syncMinicartAccessibility(false);
	setHeaderHeight();
	initVideoLoading();
	const backToTopButton = document.getElementById("back-to-top");
	if (backToTopButton) {
		const SCROLL_THRESHOLD = 400;
		let ticking = false;
		const toggleBackToTop = () => {
			backToTopButton.classList.toggle("is-visible", window.scrollY > SCROLL_THRESHOLD);
			ticking = false;
		};
		document.addEventListener("scroll", () => {
			if (ticking) return;
			window.requestAnimationFrame(toggleBackToTop);
			ticking = true;
		}, { passive: true });
		backToTopButton.addEventListener("click", () => {
			window.scrollTo({
				top: 0,
				behavior: "smooth"
			});
		});
		toggleBackToTop();
	}
})();
//#endregion
